import { render, staticRenderFns } from "./TypeAvatar.vue?vue&type=template&id=cc81617a&scoped=true&"
import script from "./TypeAvatar.vue?vue&type=script&lang=js&"
export * from "./TypeAvatar.vue?vue&type=script&lang=js&"
import style0 from "./TypeAvatar.vue?vue&type=style&index=0&id=cc81617a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc81617a",
  null
  
)

export default component.exports
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QAvatar});
